import './CABK.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CABK extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
